import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

import "./AbsenceReasons.css"

import { getReasons, editReasons } from "../../../../actions/absenceActions";

import Form from "../../../CustomViews/Form";

const AbsenceForm = reduxForm({ form: "absenceForm" })(Form);

class AbsenceReasons extends React.Component {
    constructor(props) {
        super(props);

        this.state = { editMode: false };
    }

    componentDidMount() {
        this.props.getReasons();
    }

    toggleEditMode = () => {
        this.setState({ editMode: !this.state.editMode });
    }

    onFormSubmit = (formValues, onFormError) => {
        if (formValues.nativeEvent) return;
        console.log(formValues);
        let newFormValues = {};
        for (let property in formValues) {
            property = property.split("#");
            if (!newFormValues[property[1]]) newFormValues[property[1]] = {};
            newFormValues[property[1]][property[0]] = formValues[property.join("#")];
        }
        formValues = { fields: [] };
        for (let property in newFormValues) {
            formValues.fields.push({
                absenceID: property,
                sort: +newFormValues[property].sort,
                attachmentRequired: newFormValues[property].attachmentRequired,
                active: newFormValues[property].active
            })
        }
        console.log(formValues);
        //this.props.editReasons(formValues, onFormError, this.toggleEditMode);
    }

    renderForm = () => {
        let initialValues = {};
        let fields = [];

        this.props.reasons.forEach(absence => {
            let sortName = `sort#${absence.absenceID}`;
            let attachmentRequiredName = `attachmentRequired#${absence.absenceID}`;
            let activeName = `active#${absence.absenceID}`;

            initialValues[sortName] = absence.sort;
            initialValues[attachmentRequiredName] = absence.attachmentRequired === 1 ? true : false;
            initialValues[activeName] = absence.active === 1 ? true : false;
            fields.push({
                code: absence.code,
                symbol: absence.symbol,
                name: absence.name,
                modifiedBy: absence.modifiedBy,
                modifiedOn: absence.modifiedOn,
                sortName: sortName,
                attachmentRequiredName: attachmentRequiredName,
                activeName: activeName
            });
        });

        fields.push({ type: "divider" });
        fields.push({ type: "button" });

        return (
            <AbsenceForm initialValues={initialValues} onSubmit={this.onFormSubmit} fields={fields} renderFields={this.renderFields} />
        );
    }

    renderFields = (fields, _, __, renderInput, formErrors, renderError) => {
        return (
            <table>
                <tbody>
                    {fields.map((field, index) => {
                        return this.renderRow(index, false, field.code, field.symbol, field.name, field.modifiedBy, field.modifiedOn, "", false, false, field, renderInput, formErrors, renderError);
                    })}
                </tbody>
            </table>
        );
    }

    renderRows = () => {
        return (
            <React.Fragment>
                <table>
                    <tbody>
                        {this.props.reasons.map((absence, index) => {
                            return this.renderRow(index, false, absence.code, absence.symbol, absence.name, absence.modifiedBy, absence.modifiedOn, absence.sort, absence.attachmentRequired, absence.active);
                        })}
                    </tbody>
                </table>
                <div className="ui divider" />
                <button className="ui primary button" onClick={this.toggleEditMode}>Edytuj</button>
            </React.Fragment>
        );
    }

    renderHeader = () => {
        return (
            <table>
                <tbody>
                    {this.renderRow("header", true, "Kod", "Symbol", "Nazwa", "Modyfikował", "", "Kolejność", "Załącznik", "Aktywne")}
                </tbody>
            </table>
        );
    }

    renderRow(key, header, code, symbol, name, modifiedBy, modifiedOn, sort = "", attachmentRequired = false, active = false, field = {}, renderInput = null, formErrors = null, renderError = null) {
        let error;
        if (formErrors && !field.type) error = formErrors.filter(err => (field.sortName === `sort#${err.absenceID}` || field.activeName === `active#${err.absenceID}`))[0];

        return (
            <React.Fragment key={key}>
                <tr>
                    {this.state.editMode && field.type ? (
                        <td colSpan="6">
                            {field.type === "divider" ? (
                                <div className="ui divider" />   
                            ) : (
                                <button className="ui primary button" onClick={this.onFormSubmit}>Zapisz</button>
                            )}
                        </td>
                    ) : (
                        <React.Fragment>
                            <td className={`small ${header ? "header" : ""}`}>{code}</td>
                            <td className={`small ${header ? "header" : ""}`}>{symbol}</td>
                            <td className={`big ${header ? "header" : ""}`}>{name}</td>
                            <td className={`small ${header ? "header" : ""}`}>
                                {this.state.editMode && !header ? (
                                    <div className="field">
                                        <Field type="number" name={field.sortName} component={renderInput} />
                                    </div>
                                ) : sort}
                            </td>
                            <td className={`small ${header ? "header" : ""}`}>
                                {this.state.editMode && !header ? (
                                    <div className="field">
                                        <Field type="checkbox" name={field.attachmentRequiredName} component={renderInput} />
                                    </div>
                                ) : (header ? attachmentRequired : (attachmentRequired === 1 ? "tak" : "nie"))}
                            </td>
                            <td className={`small ${header ? "header" : ""}`}>
                                {this.state.editMode && !header ? (
                                    <div className="field">
                                        <Field type="checkbox" name={field.activeName} component={renderInput} />
                                    </div>
                                ) : (header ? active : (active === 1 ? "tak" : "nie"))}
                            </td>
                            <td className={`big ${header ? "header" : ""}`}>{header ? modifiedBy : (modifiedBy ? (
                                <React.Fragment>{modifiedBy}<br />{modifiedOn}</React.Fragment>
                            ) : "---")}</td>
                        </React.Fragment>
                    )}
                </tr>
                {error ? (
                    <tr>
                        <td colSpan="6">
                            {renderError(error)}
                        </td>
                    </tr>
                ) : null}
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="absence-reasons-component ui container">
                <div className="ui three item menu">
                        <Link to="/structure" className="item">
                            <div className="content">Struktura firmy</div>
                        </Link>
                        <Link to="/absence/reasons" className="active item">
                            <div className="content">Przyczyny absencji</div>
                        </Link>
                        <Link to="/settings" className="item">
                            <div className="content">Pozostałe ustawienia</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        <div className="ui large header">
                            <div className="content">Przyczyny absencji</div>
                        </div>
                        {this.renderHeader()}
                        {this.state.editMode ? (
                            <React.Fragment>
                                {this.renderForm()}
                                <div className="cancel">
                                    <button className="ui button" onClick={this.toggleEditMode}>Anuluj</button>
                                </div>
                            </React.Fragment>
                        ) : (
                            this.renderRows()
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({ reasons: state.absence.reasons });

export default connect(mapStateToProps, { getReasons, editReasons })(AbsenceReasons);